import { Service } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Service({ autoProvided: false })
export class ForbiddenService {
  private _isForbidden$: Subject<boolean> = new Subject<boolean>();

  isForbidden$: Observable<boolean> = this._isForbidden$.asObservable();

  forbid(): void {
    this._isForbidden$.next(true);
  }

  allow(): void {
    this._isForbidden$.next(false);
  }
}
